<sh-toggle [label]="label()" [active]="active" [disabled]="disabled"></sh-toggle>
